//need double verification
const portalLayer3 = [
    {
        icon: "01n",
        description: "clear sky",
        style:
            {
            backgroundImage: "var(--PartSky_Night)",
            backgroundSize: "cover",
            transform: "rotate(90deg)",
            opacity: "0.3",
            animation: "twinkle 3s linear infinite",
            }

    },
    {
        icon: "09d",
        description: "shower rain",
        style:
            {
            backgroundImage: "var(--Sky_Drizzle)",
            backgroundSize: "cover",
            opacity: "0.3",
            animation: "wind 500s linear infinite",
            },
    },
    {
        icon: "09n",
        description: "shower rain",
        style:
            {
            backgroundImage: "var(--Sky_Drizzle)",
            backgroundSize: "cover",
            opacity: "0.2",
            animation: "wind 500s linear infinite",
            },
    },
    {
        icon: "10d",
        description: "rain",
        style:
            {
            backgroundImage: "var(--Drizzle_Day)",
            backgroundSize: "50% 50%",
            opacity: "0.2",
            animation: "slowrain 0.7s linear infinite",
            },
    },
    {
        icon: "10n",
        description: "rain",
        style:
            {
            backgroundImage: "var(--Drizzle_Night)",
            backgroundSize: "50% 50%",
            opacity: "0.15",
            animation: "slowrain 1s linear infinite",
            },
    },
    {
        icon: "11d",
        description: "thunderstorm",
        style:
            {
            backgroundImage: "var(--Large_Rain)",
            backgroundSize: "50% 50%",
            opacity: "0.2",
            animation: "rain 0.5s linear infinite",
            },
    },
    {
        icon: "11n",
        description: "thunderstorm",
        style: 
            {
            backgroundImage: "var(--Large_Rain)",
            backgroundSize: "50% 50%",
            opacity: "0.2",
            animation: "rain 0.5s linear infinite",
            },
    },
    {
        icon: "13d",
        description: "snow",
        style:
            {
            backgroundImage: "var(--SnowLargeDay)",
            opacity: "0.8",
            transform: "rotate(-20deg)",
            animation: "fall-reverse 3s linear infinite",
            filter: "blur(3px)",
            },
    },
    {
        icon: "13n",
        description: "snow",
        style:
            {
            backgroundImage: "var(--SnowLargeNight)",
            opacity: "0.3",
            transform: "rotate(-10deg)",
            animation: "fall-reverse 2.5s linear infinite",
            filter: "blur(3px)",
            },
    },
];

export default portalLayer3;